module.exports = __webpack_public_path__ + "static/special-offer-af452d0d2430f48bc0f74202d54f04dc.svg";